import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-scroll-progress',
  templateUrl: './scroll-progress.component.html',
  styleUrls: ['./scroll-progress.component.css']
})
export class ScrollProgressComponent {
  @HostListener('window:scroll', ['$event'])
  onScroll(): void {
    this.updateScrollProgress();
  }

  updateScrollProgress(): void {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrollPercent = (scrollTop / scrollHeight) * 100;
    
    const scrollPoint = document.querySelector('.scroll-point');
    if (scrollPoint) {
      (scrollPoint as HTMLElement).style.transform = `translateY(${scrollPercent}%)`;
    }
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

